import {
  trapFocusOnModal,
  removeTrapFocusOnModal,
  getFocusableElements
} from "../../utils/TrapFocus";

export default class LayerMenuPanel {
  get CLASSNAMES() {
    return {
      show: "show-panel"
    };
  }
  constructor(panelElement) {
    this.isActive = false;
    this.panelElement = panelElement;
    this.panelTitle = this.panelElement.querySelector("[data-panel-title]");
    this.backBtn = this.panelElement.querySelector("[data-close-panel]");
    this.leaveHandler = () => "";
    this.backHandler = () => "";
    this.trapFocusHandler = () => "";
  }
  onLeave(callback) {
    let mq = window.matchMedia("(min-width:992px)");
    if (!mq.matches) {
      return;
    }
    this.leaveHandler = callback;
    this.panelElement.addEventListener("mouseleave", this.leaveHandler);
  }
  isDesktop() {
    return !!window.matchMedia("(min-width:992px)").matches;
  }
  whenBack(callback) {
    this.backHandler = callback;
    this.backBtn.addEventListener("click", this.backHandler);
  }
  showLayer() {
    if (this.isDesktop()) {
      this.backBtn.setAttribute("tabindex", "-1");
    }
    this.panelElement.classList.add(this.CLASSNAMES.show);
    this.panelElement.setAttribute("aria-hidden", "false");
    this.panelElement.setAttribute("tabindex", "0");
    this.trapFocusHandler = trapFocusOnModal(this.panelElement);
    this.panelElement.addEventListener(
      "transitionend",
      this.focusOnFirstFocusable
    );

    this.isActive = true;
  }
  focusOnFirstFocusable() {
    const panelFocusableEls = getFocusableElements(this);
    if (panelFocusableEls.length > 0) {
      panelFocusableEls[0].focus();
    }
  }
  hideLayer() {
    this.panelElement.classList.remove(this.CLASSNAMES.show);
    this.panelElement.setAttribute("aria-hidden", "true");
    this.panelElement.setAttribute("tabindex", "-1");
    removeTrapFocusOnModal(this.panelElement, this.trapFocusHandler);
    this.panelElement.removeEventListener("mouseleave", this.leaveHandler);
    this.backBtn.removeEventListener("click", this.backHandler);
    this.isActive = false;
    this.panelElement.removeEventListener(
      "transitionend",
      this.focusOnFirstFocusable
    );
  }
  setTitle(text) {
    if (!this.panelTitle) {
      return;
    }
    this.panelTitle.innerText = text;
  }
  checkChild(element) {
    return this.panelElement.contains(element);
  }
}
